import React from "react";
import styled from "styled-components";
import { ProgressBar } from "react-bootstrap";
import { compassLightGreen } from "../../styles";

const Container = styled.div<{ height?: number }>`
  height: ${({ height }): string => (height ? `${height}px` : "12px")};

  width: 100%;
`;

const ProgressBarParent = styled(ProgressBar)<{ height?: number }>`
  height: ${({ height }): string => (height ? `${height}px` : "12px")};
`;

const StyledProgressBar = styled(ProgressBar)<{ color?: string }>`
  background-color: ${({ color }): string => color || compassLightGreen};
`;

export const CompassProgressBar = ({
  value,
  max = 100,
  height,
  color,
}: CompassProgressBarProps): JSX.Element => {
  return (
    <Container height={height}>
      <ProgressBarParent height={height}>
        <StyledProgressBar now={value} max={max} color={color} />
      </ProgressBarParent>
    </Container>
  );
};

export type CompassProgressBarProps = {
  value: number;
  max?: number;
  height?: number;
  color?: string;
};
